'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-", ": 8px;\n  margin-bottom: 2px;\n  font-weight: 600 !important;\n  cursor: pointer;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  &:focus,\n  &:active,\n  &:active:focus,\n  &.active,\n  &.active:focus,\n  &.focus,\n  &:active.focus,\n  &.active.focus {\n    outline: 0 none;\n    box-shadow: none;\n  }\n  ", "\n  position: relative;\n  z-index: 1;\n\n  @keyframes loading {\n    0% {\n      width: 0%;\n    }\n    100% {\n      width: 100%;\n    }\n  }\n\n  .loading {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 0%;\n    height: 100%;\n    border-radius: inherit;\n    z-index: 1;\n    background-color: rgba(0, 0, 0, 0.12);\n    animation: loading 8s infinite linear;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Ele = styled__default['default'].button.attrs(function () {
  return {
    _component: 'button'
  };
})(_templateObject(), index.styleEngine, function (props) {
  return props.disabled || props.loading ? "\n    cursor: not-allowed;\n    opacity: 0.8;\n   " : '';
});
var StyledIcon = styled__default['default'].i(_templateObject2(), function (props) {
  return props.position === 'left' ? 'right' : 'left';
}, index.styleEngine);

var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      position = _ref.position,
      restProps = _objectWithoutProperties(_ref, ["icon", "position"]);

  return icon ? /*#__PURE__*/React__default['default'].createElement(StyledIcon, _extends({
    position: position,
    className: icon
  }, restProps)) : null;
};

Icon.propTypes = {
  icon: PropTypes__default['default'].string,
  position: PropTypes__default['default'].string
};

var Button = function Button(_ref2) {
  var isActive = _ref2.active,
      children = _ref2.children,
      icon = _ref2.icon,
      iconPosition = _ref2.iconPosition,
      iconProps = _ref2.iconProps,
      _onClick = _ref2.onClick,
      activeProps = _ref2.activeProps,
      loading = _ref2.loading,
      restProps = _objectWithoutProperties(_ref2, ["active", "children", "icon", "iconPosition", "iconProps", "onClick", "activeProps", "loading"]);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  React.useEffect(function () {
    setActive(isActive);
  }, [isActive]);
  return /*#__PURE__*/React__default['default'].createElement(Ele, _extends({
    onClick: function onClick(e) {
      e.stopPropagation();
      setActive(!active);
      _onClick && _onClick(e);
    }
  }, restProps, active ? activeProps : {}, {
    active: active,
    loading: loading
  }), iconPosition === 'left' ? /*#__PURE__*/React__default['default'].createElement(Icon, _extends({
    position: iconPosition,
    icon: icon
  }, iconProps)) : null, children, iconPosition === 'right' ? /*#__PURE__*/React__default['default'].createElement(Icon, _extends({
    position: iconPosition,
    icon: icon
  }, iconProps)) : null, loading ? /*#__PURE__*/React__default['default'].createElement("span", {
    className: "loading"
  }) : null);
};

Button.defaultProps = {
  variant: 'primary',
  size: 'default',
  iconPosition: 'right'
};
Button.propTypes = {
  /**
   * Check theme sheet for available variants
   */
  variant: PropTypes__default['default'].string,

  /**
   * Check theme sheet for available sizes
   */
  size: PropTypes__default['default'].string,

  /**
   * Supports all available icons in pyt-icon 😄
   */
  icon: PropTypes__default['default'].string,
  iconPosition: PropTypes__default['default'].oneOf(['left', 'right']),

  /**
   * Specifies what to be rendered inside the component
   */
  children: PropTypes__default['default'].node,

  /**
   * Props to customize icon. Supports all style engine props!
   */
  active: PropTypes__default['default'].bool,
  iconProps: PropTypes__default['default'].object,
  activeProps: PropTypes__default['default'].object,
  onClick: PropTypes__default['default'].func,
  loading: PropTypes__default['default'].bool
};

exports.default = Button;
